import { DataIntegrityError } from './errors'

/**
 * Assert a condition that must be true for the program to continue.
 * Throws DataIntegrityError with structured context when the condition is false.
 *
 * Usage:
 *   invariant(acute >= 0, 'Acute load cannot be negative', { acute })
 */
export function invariant(
    condition: boolean,
    message: string,
    context?: Record<string, unknown>,
): asserts condition {
    if (!condition) {
        throw new DataIntegrityError(`Invariant violation: ${message}`, context)
    }
}
